"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _mobxReact = require("mobx-react");
var _mobx = require("mobx");
var _utils = require("@seedlang/utils");
var _state = require("@seedlang/state");
var _constants = require("@seedlang/constants");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _initializerDefineProperty(e, i, r, l) { r && Object.defineProperty(e, i, { enumerable: r.enumerable, configurable: r.configurable, writable: r.writable, value: r.initializer ? r.initializer.call(l) : void 0 }); }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _possibleConstructorReturn(t, e) { if (e && ("object" == _typeof(e) || "function" == typeof e)) return e; if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined"); return _assertThisInitialized(t); }
function _assertThisInitialized(e) { if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); return e; }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
function _getPrototypeOf(t) { return _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (t) { return t.__proto__ || Object.getPrototypeOf(t); }, _getPrototypeOf(t); }
function _inherits(t, e) { if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function"); t.prototype = Object.create(e && e.prototype, { constructor: { value: t, writable: !0, configurable: !0 } }), Object.defineProperty(t, "prototype", { writable: !1 }), e && _setPrototypeOf(t, e); }
function _setPrototypeOf(t, e) { return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) { return t.__proto__ = e, t; }, _setPrototypeOf(t, e); }
function _applyDecoratedDescriptor(i, e, r, n, l) { var a = {}; return Object.keys(n).forEach(function (i) { a[i] = n[i]; }), a.enumerable = !!a.enumerable, a.configurable = !!a.configurable, ("value" in a || a.initializer) && (a.writable = !0), a = r.slice().reverse().reduce(function (r, n) { return n(i, e, r) || r; }, a), l && void 0 !== a.initializer && (a.value = a.initializer ? a.initializer.call(l) : void 0, a.initializer = void 0), void 0 === a.initializer ? (Object.defineProperty(i, e, a), null) : a; }
function _initializerWarningHelper(r, e) { throw Error("Decorating class property failed. Please ensure that transform-class-properties is enabled and runs after the decorators transform."); }
var GenderCardWrapper = function GenderCardWrapper(Component) {
  var _class, _class2, _descriptor;
  return (0, _mobxReact.observer)(_class = (_class2 = /*#__PURE__*/function (_React$Component) {
    function _class2(props) {
      var _this;
      _classCallCheck(this, _class2);
      _this = _callSuper(this, _class2, [props]);
      _initializerDefineProperty(_this, "buttonColors", _descriptor, _this);
      _this.onClick = function (value) {
        _this.props.cardState.selectedOptionText = value;
        if (!_this.props.card.word.targetTextWithDefiniteArticle.match(/^l'/) && value === _this.props.card.word.gender || value === 'apostrophe' && _this.props.card.word.targetTextWithDefiniteArticle.match(/^l'/)) {
          _this.props.userCard.set('score', 1);
          _this.buttonColors[value] = _constants.Theme.green;
          _state.DeckUI.onCorrectAnswer(_this.props.card, _this.props.cardState, _this.props.userCard, {
            xp: 1,
            xpSlug: 'gender'
          });
        } else {
          _this.buttonColors[value] = _constants.Theme.red;
          _this.props.userCard.set('seen', true);
          _state.DeckUI.onIncorrectAnswer(_this.props.card, _this.props.cardState, _this.props.userCard);
        }
        setTimeout(function () {
          return _state.DeckUI.reveal(_this.props.card, _this.props.cardState);
        }, 500);
      };
      _state.DeckUI.enrichWord(_this.props.card);
      return _this;
    }
    _inherits(_class2, _React$Component);
    return _createClass(_class2, [{
      key: "revealed",
      get: function get() {
        return this.props.cardState.revealed;
      }
    }, {
      key: "showText",
      get: function get() {
        return this.props.card && this.props.card.word;
      }
    }, {
      key: "description",
      get: function get() {
        return this.revealed && this.showText && (0, _utils.isPresent)(this.props.card.concept) && (0, _utils.isPresent)(this.props.card.concept.shortDescription) ? this.props.card.concept.shortDescription : null;
      }
    }, {
      key: "icons",
      get: function get() {
        var ary = [];
        if ((0, _utils.isPresent)(this.props.card.grammarTip)) {
          ary.push('grammarTip');
        }
        if (_state.DeckUI.reviewDeck && this.props.cardState.revealed) {
          ary.push('reviewDetails');
        }
        if (!_state.DeckUI.reviewDeck && this.props.cardState.revealed) {
          ary.push('toggleReview');
        }
        if (this.props.cardState.revealed) {
          ary.push('cardComments');
        }
        if (_state.DeckUI.reviewDeck && (this.props.cardState.revealed || this.props.card.showNoteBeforeReveal)) {
          ary.push('cardNote');
        }
        if (this.props.cardState.revealed) {
          ary.push('vocabCard');
        }
        return ary;
      }
    }, {
      key: "definiteArticleOptions",
      get: function get() {
        var _this$props$card$word;
        switch (((_this$props$card$word = this.props.card.word) === null || _this$props$card$word === void 0 ? void 0 : _this$props$card$word.languageId) || this.props.card.languageId) {
          case 'FR':
            return [['masculine', 'Le'], ['feminine', 'La'], ['apostrophe', 'L\'']];
          case 'ES':
            return [['masculine', 'El'], ['feminine', 'La']];
          default:
            return [['masculine', 'Der'], ['feminine', 'Die'], ['neuter', 'Das']];
        }
      }
    }, {
      key: "render",
      value: function render() {
        return /*#__PURE__*/_react["default"].createElement(Component, _extends({}, this.props, {
          revealed: this.revealed,
          showText: this.showText,
          description: this.description,
          onClick: this.onClick,
          icons: this.icons,
          buttonColors: this.buttonColors,
          definiteArticleOptions: this.definiteArticleOptions
        }));
      }
    }]);
  }(_react["default"].Component), _descriptor = _applyDecoratedDescriptor(_class2.prototype, "buttonColors", [_mobx.observable], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function initializer() {
      return {
        masculine: _state.DeckUI.layout.isNative && _state.DeckUI.layout.darkMode ? _state.DeckUI.layout.secondaryBackgroundColor : '#FFF',
        feminine: _state.DeckUI.layout.isNative && _state.DeckUI.layout.darkMode ? _state.DeckUI.layout.secondaryBackgroundColor : '#FFF',
        neuter: _state.DeckUI.layout.isNative && _state.DeckUI.layout.darkMode ? _state.DeckUI.layout.secondaryBackgroundColor : '#FFF',
        apostrophe: _state.DeckUI.layout.isNative && _state.DeckUI.layout.darkMode ? _state.DeckUI.layout.secondaryBackgroundColor : '#FFF'
      };
    }
  }), _applyDecoratedDescriptor(_class2.prototype, "revealed", [_mobx.computed], Object.getOwnPropertyDescriptor(_class2.prototype, "revealed"), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, "showText", [_mobx.computed], Object.getOwnPropertyDescriptor(_class2.prototype, "showText"), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, "description", [_mobx.computed], Object.getOwnPropertyDescriptor(_class2.prototype, "description"), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, "icons", [_mobx.computed], Object.getOwnPropertyDescriptor(_class2.prototype, "icons"), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, "definiteArticleOptions", [_mobx.computed], Object.getOwnPropertyDescriptor(_class2.prototype, "definiteArticleOptions"), _class2.prototype), _class2)) || _class;
};
GenderCardWrapper.displayName = 'GenderCardWrapper';
var _default = exports["default"] = GenderCardWrapper;